<template>
    <div class="form-container">
        <h2>Edit Medical Tests</h2>
        <hr />

        <form @submit.prevent="submitForm">
            <div class="row">
                <div class="col-md-6 mb-2">
                    <label>Dental Exam Date</label>
                    <input type="date" v-model="form.dental_exam_date" class="form-control" />
                    <div v-if="errors.dental_exam_date" class="text-danger small">{{ errors.dental_exam_date[0] }}</div>
                </div>
                <div class="col-md-6 mb-2">
                    <label>Dental Exam Location</label>
                    <input type="text" v-model="form.dental_exam_location" class="form-control" />
                    <div v-if="errors.dental_exam_location" class="text-danger small">{{ errors.dental_exam_location[0]
                        }}</div>
                </div>

                <div class="col-md-6 mb-2">
                    <label>Chest X-ray Date</label>
                    <input type="date" v-model="form.chest_xray_date" class="form-control" />
                    <div v-if="errors.chest_xray_date" class="text-danger small">{{ errors.chest_xray_date[0] }}</div>
                </div>
                <div class="col-md-6 mb-2">
                    <label>Chest X-ray Location</label>
                    <input type="text" v-model="form.chest_xray_location" class="form-control" />
                    <div v-if="errors.chest_xray_location" class="text-danger small">{{ errors.chest_xray_location[0] }}
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-4 mb-2" v-for="field in booleanFields" :key="field.key">
                    <label>{{ field.label }}</label>
                    <div class="d-flex align-items-center gap-3">
                        <label><input type="radio" v-model="form[field.key]" :value="true" /> Yes</label>
                        <label><input type="radio" v-model="form[field.key]" :value="false" /> No</label>
                    </div>
                    <div v-if="errors[field.key]" class="text-danger small">{{ errors[field.key][0] }}</div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-4 mb-2" v-for="field in textFields" :key="field.key">
                    <label>{{ field.label }}</label>
                    <input type="text" v-model="form[field.key]" class="form-control" />
                    <div v-if="errors[field.key]" class="text-danger small">{{ errors[field.key][0] }}</div>
                </div>
            </div>

            <button type="submit" class="btn btn-success mt-3">💾 Save</button>
        </form>
    </div>
</template>

<script>
export default {
    name: 'IOPMedicalTest',
    props: ['iop_medical_print_id'],
    data() {
        return {
            form: {
                iop_medical_print_id: this.iop_medical_print_id,
                dental_exam_date: '',
                dental_exam_location: '',
                chest_xray_date: '',
                chest_xray_location: '',
                hiv_test: false,
                hiv_result: '',
                hep_b_test: false,
                hep_b_result: '',
                hep_c_test: false,
                hep_c_result: '',
                overdose: false,
                overdose_count: '',
                overdose_when: '',
                opioid_treatment: false,
                opioid_facility: '',
                opioid_date: '',
                opioid_dose: '',
                opioid_takehome: '',
                opioid_reason: ''
            },
            errors: {},
            booleanFields: [
                { key: 'hiv_test', label: 'HIV Test' },
                { key: 'hep_b_test', label: 'Hep B Test' },
                { key: 'hep_c_test', label: 'Hep C Test' },
                { key: 'overdose', label: 'Overdose' },
                { key: 'opioid_treatment', label: 'Opioid Treatment' }
            ],
            textFields: [
                { key: 'hiv_result', label: 'HIV Result' },
                { key: 'hep_b_result', label: 'Hep B Result' },
                { key: 'hep_c_result', label: 'Hep C Result' },
                { key: 'overdose_count', label: 'Overdose Count' },
                { key: 'overdose_when', label: 'Overdose When' },
                { key: 'opioid_facility', label: 'Opioid Facility' },
                { key: 'opioid_date', label: 'Opioid Date' },
                { key: 'opioid_dose', label: 'Opioid Dose' },
                { key: 'opioid_takehome', label: 'Opioid Takehome' },
                { key: 'opioid_reason', label: 'Opioid Reason' }
            ]
        };
    },
    mounted() {
        this.loadForm();
    },
    methods: {
        async loadForm() {
            try {
                const res = await this.$api.get(`/iop-medical-tests/${this.iop_medical_print_id}`);
                if (res.data && Object.keys(res.data).length > 0) {
                    this.form = { ...this.form, ...res.data };
                }
            } catch (err) {
                // ignore
            }
        },

        async submitForm() {
            this.errors = {};
            try {
                await this.$api.post(`/iop-medical-tests`, this.form);
                this.$router.back();
            } catch (err) {
                if (err.response?.data?.errors) {
                    this.errors = err.response.data.errors;
                } else {
                    alert('Failed to save Medical Tests');
                }
            }
        }
    }
};
</script>

<style scoped>
label {
    font-weight: 500;
}
</style>